module.exports = __webpack_public_path__ + "a3dc76659aeddc3c567d1a6f565954fc.svg";